import React, { useState } from 'react';
import { toast } from 'react-toastify';
import styles from './AddNoteModal.module.css';
import api from '../api';

const AddNoteModal = ({ isOpen, ticketId, propertyId, onClose, onSuccess, onNoteAdded }) => {
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState('');
  const [noteType, setNoteType] = useState('property_note');
  const [pinToTop, setPinToTop] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!description.trim()) {
      toast.error('Please enter a note description');
      return;
    }

    setLoading(true);
    try {
      // Determine the endpoint based on what ID is provided
      const endpoint = ticketId
        ? `/tickets/${ticketId}/notes`
        : `/notes/properties/${propertyId}`;

      const response = await api.post(endpoint, {
        content: description.trim(),
        type: noteType,
        is_flagged: pinToTop,
        object: 'property',
        object_id: propertyId
      });

      const data = response.data;
      toast.success('Note added successfully!');

      // Call the appropriate success callback
      if (onSuccess) {
        onSuccess();
      }
      if (onNoteAdded) {
        onNoteAdded(data);
      }

      // Close the modal after successful add
      onClose();

      // Reset form
      setDescription('');
      setNoteType('property_note');
      setPinToTop(false);
    } catch (error) {
      console.error('Error adding note:', error);
      toast.error(error.message || 'Failed to add note');
    } finally {
      setLoading(false);
    }
  };



  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h3>Add note to property</h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.modalBody}>
            <div className={styles.formGroup}>
              <label htmlFor="noteType">Note Type</label>
              <select
                id="noteType"
                className={styles.select}
                value={noteType}
                onChange={(e) => setNoteType(e.target.value)}
                required
              >
                <option value="property_note">Property Note</option>
                <option value="fit_out_note">Fit Out Note</option>
                <option value="utility_note">Utility Note</option>
              </select>
            </div>
            
            <div className={styles.formGroup}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={pinToTop}
                  onChange={(e) => setPinToTop(e.target.checked)}
                  className={styles.checkbox}
                />
                Pin to top
              </label>
            </div>


            <div className={styles.formGroup}>
              <textarea
                className={styles.textarea}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={6}
                placeholder="Enter your note here..."
                required
              />
            </div>
          </div>
          <div className={styles.modalFooter}>
            <button
              type="submit"
              className={styles.addButton}
              disabled={loading || !description.trim()}
            >
              <span className={styles.plusIcon}>+</span>
              {loading ? 'Adding...' : 'Add Note'}
            </button>
            <button
              type="button"
              className={styles.closeButton}
              onClick={onClose}
              disabled={loading}
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNoteModal;